import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    num: '01',
    title: 'KIT DE ARRANQUE RÁPIDO FINANCIERO',
    desc: 'Empezá con claridad total en menos de 30 minutos. Diagnóstico express. Semáforo financiero. Plan 7 días.',
    value: '$490'
  }, {
    num: '02',
    title: 'CHECKLIST DE ERRORES FINANCIEROS',
    desc: 'Detectá los drenajes invisibles que te hacen perder dinero. 26 errores. 10 drenajes invisibles. Plan de corrección.',
    value: '$390'
  }, {
    num: '03',
    title: 'PLANIFICADOR SEMANAL DE CONTROL ECONÓMICO',
    desc: 'Organizá tu semana financiera en 10 minutos. 6 hojas semanales. 3 trackers. Tablero de decisiones.',
    value: '$390'
  }, {
    num: '04',
    title: 'GUÍA DE PRIORIDADES CUANDO LA PLATA NO ALCANZA',
    desc: 'Decidís sin pánico cuando el dinero no alcanza para todo. Matriz 3 niveles. Regla 4D. Protocolo de 24 horas.',
    value: '$390'
  }, {
    num: '05',
    title: 'TRACKER DE PROGRESO ECONÓMICO DE 30 DÍAS',
    desc: 'Medí tu avance con evidencia real y visible. Tabla 30 días. Revisión semanal. 4 mini retos.',
    value: '$390'
  }, {
    num: '06',
    title: 'MINI GUÍA DE RESPUESTAS RÁPIDAS',
    desc: 'Decidís bien en cualquier momento de presión o confusión. 5 preguntas filtro. 5 situaciones comunes. Printable.',
    value: '$390'
  }];
  return <section className="py-12 md:py-20 px-4 bg-brand-dark relative" data-id="element-53">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-radial-gold opacity-50 pointer-events-none" data-id="element-54" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-black text-white flex items-center justify-center gap-3" data-id="element-57">
            <Gift className="w-8 h-8 text-gold" data-id="element-58" />6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-gold uppercase tracking-widest font-bold mt-2" data-id="element-59">
            — SIEMPRE INCLUIDOS —
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-60">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-green border border-gold/20 rounded-xl p-5 flex gap-4 hover:border-gold/50 transition-colors" data-id="element-61">
              <div className="text-3xl font-black text-gold/20" data-id="element-62">{bono.num}</div>
              <div className="flex-1" data-id="element-63">
                <div className="flex items-center gap-2 mb-2" data-id="element-64">
                  <Gift className="w-4 h-4 text-gold" data-id="element-65" />
                  <h4 className="text-white font-bold text-sm uppercase leading-tight" data-id="element-66">
                    BONO {parseInt(bono.num)} — {bono.title}
                  </h4>
                </div>
                <p className="text-cream/70 text-sm mb-3 leading-relaxed" data-id="element-67">
                  {bono.desc}
                </p>
                <div className="flex items-center justify-end gap-2 text-sm font-bold" data-id="element-68">
                  <span className="text-red-400 line-through" data-id="element-69">
                    {bono.value}
                  </span>
                  <span className="text-gold" data-id="element-70">→ GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold/10 via-gold/20 to-gold/10 border border-gold/40 rounded-2xl p-6 text-center shadow-gold-glow" data-id="element-71">
          <p className="text-cream text-lg mb-1" data-id="element-72">
            Valor total de los 6 bonos:{' '}
            <span className="line-through text-white/50" data-id="element-73">$2,430 UYU</span>
          </p>
          <p className="text-2xl md:text-3xl font-black text-gold-gradient uppercase" data-id="element-74">
            → GRATIS con tu Sistema Libre de Clearing
          </p>
        </motion.div>
      </div>
    </section>;
}